module.exports = __webpack_public_path__ + "b9d3ef8f05571afbe45b4bdb7fa527b7.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/li1-61.png
// module id = 605
// module chunks = 0